
<template>
  <v-app id="onErrs">
    <v-main>
    <v-container fluid>  
    <v-card>
      
      Nr: {{errs.errs_nr}}  

      <span v-for="(errstaalRecord,i) in errs.errstaal" :key="i">
       <br>
       {{errstaalRecord.taal_code}}  <v-btn class="primary ma-2" small @click="saveErrstaal(errstaalRecord)">Save</v-btn><br>
       <v-textarea v-model="errstaalRecord.errstaal_oms" :value=errstaalRecord.errstaal_oms rows="1" label="Translation" spellcheck="false"></v-textarea>
       <br>
      </span>  
    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/> 
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar,
  },
  props: ['errs_encrid'],
  data() {
    return {
      errs: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/errs/getErrs.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getErrs"
          },
          getErrs: {
             errs_encrid: this.errs_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.errs = res.data.getErrs;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveErrstaal(errstaal) { 
      this.$axios
        .post("ares/json/ares/syst/ref/errs/saveErrstaal.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveErrstaal"
          },
          saveErrstaal: {
            errstaal: errstaal
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveErrstaal.text,
              color: res.data.saveErrstaal.color
            });
          }
        })
    }
  }  

};

</script> 
